<template>
  <div class="container-fluid">
    <div class="loader_fs" v-if="loading">
      <Loader />
    </div>
    <div class="row">
      <div class="col-md-12">
        <transition :name="animations.fadeIn.name" :enter-active-class="animations.fadeIn.enter" :leave-active-class="animations.fadeIn.leave">
          <div class="card">
            <div class="card-header">
              <h5>Kunden</h5>
            </div>
            <div class="card-body">
              <b-row>
                <b-col md="12" class="list_mode iam-table-ux">
                  <b-input-group class="datatable-btn">
                    <div class="input-group">
                      <b-form-input style="border:1px solid lightgrey" v-model="filter" placeholder="Suchen"></b-form-input>
                    </div>
                  </b-input-group>
                </b-col>
              </b-row>
              <div class="table-responsive datatable-vue">
                <b-table
                  :select-mode="selectMode"
                  show-empty
                  stacked="md"
                  selectedVariant="success"
                  :items="items"
                  :fields="tablefields"
                  :filter="filter"
                  :current-page="currentPage"
                  :per-page="perPage"
                  @filtered="onFiltered"
                >
                  <template v-slot:cell(aktionen)="row">
                    <div class="input-group iam-buttons">
                      <feather
                        :id="'edit-kunde-' + row.item.id"
                        type="edit-2"
                        class="infra-blue icon-margin-right pointer"
                        :disabled="!allReady"
                        @click="$router.push('kunde/' + row.item.id)"
                      ></feather>
                      <b-tooltip :target="'edit-kunde-' + row.item.id" triggers="hover" placement="left">Kunde bearbeiten</b-tooltip>
                    </div>
                  </template>
                  <template v-slot:cell(auswahl)="selection">
                    <input type="checkbox" name="selectedKunde" @click="handleSelect(selection)" />
                  </template>
                  <template slot="empty"><div class="text-center">Keine Kunden gefunden.</div></template>
                </b-table>
              </div>
              <div v-if="totalRows > perPage" class="flex-row-sb">
                <b-col md="6" class="my-1">
                  <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                </b-col>
                <b-button class="btn btn-primary" size="md" @click="openModal('newKunde')">Neuer Kunde</b-button>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
    <b-modal id="newKunde" @ok.prevent="validate" @cancel="closeModal('newKunde')">
      <div class="card-body">
        <label>Vorname</label>&nbsp;
        <div class="red inline-block" v-if="hasError('first_name')">- mindestens {{ validation.kunden.first_name.minlength }} Zeichen.</div>
        <b-input-group prepend="Abc" class="form-input-group">
          <b-form-input v-model="modal.first_name" v-bind:class="{ form_error: hasError('first_name') }"></b-form-input>
        </b-input-group>
        <label>Nachname</label>&nbsp;
        <div class="red inline-block" v-if="hasError('last_name')">- mindestens {{ validation.kunden.last_name.minlength }} Zeichen.</div>
        <b-input-group prepend="Abc" class="form-input-group">
          <b-form-input v-model="modal.last_name" v-bind:class="{ form_error: hasError('last_name') }"></b-form-input>
        </b-input-group>
        <label>Email</label>&nbsp;
        <div class="red inline-block" v-if="hasError('email')">- gültige Email Addresse eingeben.</div>
        <b-input-group prepend="@" class="form-input-group">
          <b-form-input v-model="modal.email" v-bind:class="{ form_error: hasError('email') }"></b-form-input>
        </b-input-group>
        <div class="inline-block passwort-label">
          <input type="checkbox" v-model="modal.sendMail" class="inline-block" />
          <label>Passwort per E-Mail schicken</label>
        </div>
      </div>
      <template slot="modal-ok">Erstellen</template>
      <template slot="modal-cancel">Abbrechen</template>
      <template slot="modal-title">Neuer Kunde</template>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Loader from "@/components/loader.vue";

export default {
  name: "AdminKunden",
  data() {
    return {
      modes: ["multi", "single", "range"],

      tablefields: [
        { key: "last_name", label: "Name", sortable: true },
        { key: "first_name", label: "Vorname", sortable: true },
        { key: "email", label: "E-Mail", sortable: true },
        { key: "telefon", label: "Phone", sortable: true },
        { key: "last_login", label: "Letzter Login", sortable: true},
        { key: "aktionen", label: "Aktionen", sortable: false }        
      ],
      items: [],
      filter: null,
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 50, 100],
      selectMode: "single",
      selected: [],
      loading: false,
      validation_errors: [],
      modal: {
        first_name: "",
        last_name: "",
        email: "",
        sendMail: true,
      },
    };
  },

  components: {
    Loader: Loader,
  },
  computed: {
    ...mapGetters({
      kunden: "app/kunden",
      animations: "app/animations",
      toasts: "app/toasts",
      ready: "app/readyState",
      validation: "app/validation",
    }),
    allReady() {
      return this.ready.kunden && this.ready.wohnungen && this.ready.bauprojekte && this.ready.hauser ? true : false;
    },
    sortOptions() {
      // Create an options list from our fields
      return this.tablefields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
  },
  async mounted() {
    // Set the initial number of items
    this.totalRows = this.items.length;
  },
  async created() {
    try {
      this.loading = true;
      await this.$store.dispatch("app/apiGetKunden");
    } catch (error) {
      console.log(error);
      this.loading = false;
    }

    this.items = this.kunden;
    this.loading = false;
    this.totalRows = this.items.length;
  },
  methods: {
    async validate() {
      this.validation_errors = [];
      const fields = ["first_name", "last_name", "email"];

      await Promise.all(
        fields.map(async (field) => {
          const result = await this.$store.dispatch("app/validateField", { context: "kunden", field, value: this.modal[field] });
          if (!result) this.validation_errors.push(field);
        })
      );

      if (!this.validation_errors.length) this.createKunde();
    },
    async createKunde() {
      //create the password
      const password = await this.$store.dispatch("app/generatePassword");

      //set payload for creation
      const createKundePayload = {
        first_name: this.modal.first_name,
        last_name: this.modal.last_name,
        email: this.modal.email,
        sendMail: this.modal.sendMail,
        role: 3,
        status: "active",
        password,
      };

      //create the kunde
      try {
        const response = await this.$store.dispatch("app/createKunde", createKundePayload);
        await this.$store.dispatch("app/apiGetKunden");
        this.closeModal("newKunde");
        this.$router.push("/admin/dashboard/kunde/" + response.data.id);
      } catch (error) {
        this.$toasted.show(error, this.toasts.failure);
      }
    },
    hasError(field) {
      return this.validation_errors.indexOf(field) > -1 ? true : false;
    },
    openModal(modalName) {
      this.$bvModal.show(modalName);
    },
    closeModal(modalName) {
      this.$bvModal.hide(modalName);
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    deleteRow(index) {
      this.items.splice(index, 1);
    },
    deleteBatchRow() {
      for (var i = 0; i < this.selected.length; i++) {
        if (this.items[i].id == this.selected[i].id) {
          this.items.splice(this.items[i], 1);
        }
      }
    },
    debug() {
      console.log(this.selected);
    },
    startChat(recipient) {
      console.log("starting to chat with " + recipient);
    },
    handleSelect(selection) {
      let isSelected = this.selected.indexOf(selection.item);
      if (isSelected > -1) {
        this.selected.splice(isSelected, 1);
      } else {
        this.selected.push(selection.item);
      }
    },
  },
};
</script>

<style>
.custom-select,
.datatable,
.form-row legend {
  text-align: left;
}

.form-group.datatable.select .form-row {
  display: inline-flex;
}

.form-group.datatable-select {
  display: inline-block;
  padding-left: 5px;
}

.datatable-select .form-row,
.datatable-btn {
  justify-content: flex-start;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
}

.datatable-btn {
  width: 33%;
}

.datatable-btn input {
  display: inline-block;
  width: 80%;
}

.form-group.datatable-select fieldset {
  width: 100%;
}

.form-row legend {
  min-width: 150px;
}

.bv-no-focus-ring .custom-select {
  min-width: 150px;
}

.list_mode .datatable-inline-label {
  font-size: 1.2em;
  position: relative;
  top: 5px;
  margin-left: 20px;
}

.list_mode .datatable-btn.input-group {
  display: flex !important;
  width: 45% !important;
  flex-flow: row !important;
  justify-content: space-between !important;
}

.list_mode .input-group select {
  flex: none !important;
  width: auto;
  margin-left: 15px;
}

.list_mode .input-group {
  width: auto;
}

.iam-buttons button {
  margin-right: 5px;
}
.passwort-label input {
  margin-right: 10px;
}
</style>
